import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { splitTestService } from '../services/splitTestService'

export const useSplitTestMetricsStore = defineStore('splitTestMetrics', () => {
  // Store metrics by test PID
  const metricsCache = ref<Record<string, any>>({})
  const loading = ref<Record<string, boolean>>({})
  
  // Fetch metrics for a specific test
  async function fetchMetrics(testPid: string) {
    // Skip if already loading or already have data
    if (loading.value[testPid] || metricsCache.value[testPid]) return
    
    loading.value[testPid] = true
    try {
      const metrics = await splitTestService.getMetrics(testPid)
      metricsCache.value[testPid] = metrics
    } catch (error) {
      console.error('splitTestMetricsStore: Failed to fetch metrics for', testPid, error)
    } finally {
      loading.value[testPid] = false
    }
  }
  
  // Get metrics for a specific test
  function getMetrics(testPid: string) {
    return metricsCache.value[testPid] || null
  }
  
  // Clear cache
  function clearCache() {
    metricsCache.value = {}
  }
  
  return {
    metricsCache: computed(() => metricsCache.value),
    loading: readonly(loading),
    fetchMetrics,
    getMetrics,
    clearCache
  }
})